import { render, staticRenderFns } from "./UReportDetail.vue?vue&type=template&id=e1028060&scoped=true"
import script from "./UReportDetail.vue?vue&type=script&lang=js"
export * from "./UReportDetail.vue?vue&type=script&lang=js"
import style0 from "./UReportDetail.vue?vue&type=style&index=0&id=e1028060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1028060",
  null
  
)

export default component.exports